import React from "react";

/**
 * ErrorState — reusable "request failed" placeholder with a Retry
 * action. `asRow` renders it inside a full-width table row (for list
 * pages); otherwise it renders as a standalone box (for form/detail
 * pages).
 */
const ErrorState = ({
  colSpan = 100,
  message = "Something went wrong while loading data.",
  onRetry,
  asRow = true,
}) => {
  const body = (
    <div className="text-center py-5 text-muted">
      <i className="bx bxs-error-circle text-danger" style={{ fontSize: 42, opacity: 0.7 }}></i>
      <p className="mb-3 mt-2">{message}</p>
      {onRetry && (
        <button type="button" className="btn btn-outline-primary btn-sm" onClick={onRetry}>
          <i className="bx bx-refresh"></i> Retry
        </button>
      )}
    </div>
  );

  if (!asRow) return body;

  return (
    <tr>
      <td colSpan={colSpan} className="p-0">
        {body}
      </td>
    </tr>
  );
};

export default ErrorState;
